import { EllipsisHorizontalIcon } from '@heroicons/react/20/solid';
import React from 'react';

import { Menu } from '@/ui-library';

import type { OptionsMenuProps } from './options-menu.types';

export const OptionsMenu: React.FC<OptionsMenuProps> = (props) => {
  const { options, onClick, position } = props;

  const handleOptionClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  ) => {
    if (!e) return;
    e.preventDefault();
    e.stopPropagation();
    onClick(e);
  };

  return (
    <Menu
      position={position}
      onClick={onClick}
      options={options.map((option) => ({
        ...option,
        onClick: (e) => handleOptionClick(e, option.onClick),
      }))}>
      <EllipsisHorizontalIcon className='w-6 h-6 text-NeutralLightDarkest hover:text-HighlightDarkest' />
    </Menu>
  );
};
